import "./utils/counter";

jQuery(document).ready(function ($) {
  // Hamburger menu & Menu mobile
  $(".navbar-toggler").on("click", function () {
    $(".wrapper-menu-mobile").toggleClass("show");
    $(".navbar-toggler").toggleClass("is-toggled");
  });
  $(window).resize(function () {
    $(".wrapper-menu-mobile").removeClass("show");
    $(".navbar-toggler").removeClass("is-toggled");
  });
  // Dropdown menu
  $(".menu-item--expanded").click(function (e) {
    $(".menu-item--expanded")
      .not(this)
      .children()
      .removeClass("submenu-active");
    $(this).children().toggleClass("submenu-active");
  });
  $(document).on("click", function (e) {
    if ($(e.target).closest(".menu-item--expanded > *").length === 0) {
      $(".menu-item--expanded > .sub-menu").removeClass("submenu-active");
      $(".menu-item--expanded > .nav-link").removeClass("submenu-active");
    }
  });
  // Accordion
  $(".accordion__wrapper__title").on("click", function () {
    $(this).children(".accordion__icon").toggleClass("open");
  });
  const accordionBtns = document.querySelectorAll(".accordion__wrapper__title");
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });

  // Apri l'accordion TOC di default e correggi altezza
  const tocAccordion = document.querySelector(
    ".toc .accordion__wrapper__title"
  );
  if (tocAccordion) {
    tocAccordion.classList.add("is-open");
    const tocIcon = tocAccordion.querySelector(".accordion__icon");
    if (tocIcon) {
      tocIcon.classList.add("open");
    }
    let content = tocAccordion.nextElementSibling;
    if (content) {
      // Correggi altezza dopo che la TOC è stata popolata
      const adjustHeight = () => {
        content.style.maxHeight = content.scrollHeight + "px";
      };
      // Esegui l'aggiustamento dopo la generazione dinamica della TOC
      setTimeout(adjustHeight, 100);
    }
  }

  // Generazione dinamica della TOC
  const tocList = document.querySelector(
    ".toc.auto .field--name-field-toc-text ul"
  );
  const articleHeadings = document.querySelectorAll(
    "article h2:not(.hero__page__wrapper h2)"
  );
  if (tocList && articleHeadings.length > 0) {
    articleHeadings.forEach((heading, index) => {
      // Genera un ID unico per ogni h2
      const textContent = heading.textContent.trim();
      const id = `${index}-${textContent.replace(/\s+/g, "-").toLowerCase()}`;
      heading.setAttribute("id", id);

      // Crea un elemento <li> con un link all'h2
      const listItem = document.createElement("li");
      const anchor = document.createElement("a");
      anchor.href = `#${id}`;
      anchor.textContent = textContent;

      // Aggiungi il link all'elemento <li> e aggiungilo alla TOC
      listItem.appendChild(anchor);
      tocList.appendChild(listItem);
    });
  }

  // swiper
  var cs2Swiper = new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      setTimeout(() => {
        location = "/grazie/";
      }, 1000);
    },
    false
  );
  // Marquee3k Initialization
  if (typeof Marquee3k !== "undefined") {
    Marquee3k.init();
    const marquee = $(".marquee3k");
    marquee.on("mouseover", Marquee3k.pauseAll);
    marquee.on("mouseout", Marquee3k.playAll);
  } else {
    console.error("Marquee3k is not loaded");
  }

    // GSAP fade-up
    if (typeof gsap !== "undefined") {
      const fadeItems = document.querySelectorAll(".js-gsap-fadeup");
  
      const isInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        return (
          rect.top <= vh * 0.9 &&
          rect.bottom >= 0
        );
      };
  
      const animateIfNeeded = () => {
        fadeItems.forEach((el) => {
          if (el.classList.contains("is-gsap-animated")) {
            return;
          }
          if (isInViewport(el)) {
            el.classList.add("is-gsap-animated");
            gsap.fromTo(
              el,
              { opacity: 0, y: 40 },
              { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }
            );
          }
        });
      };
  
      // Avvia all'onload e su scroll/resize
      animateIfNeeded();
      $(window).on("scroll resize", animateIfNeeded);
    } else {
      console.error("GSAP is not loaded");
    }
});
